import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

export const getReportePagosAlianzas = async (filters) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      alianza: filters.alianza,
      fechas: filters.fechas,
      limit: filters.limit ?? 10,
      page: filters.page ?? 0,
      order: filters.order ?? "desc",
    },
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach((val) => searchParams.append(key, val));
        } else if (params[key] != null) {
          searchParams.append(key, params[key]);
        }
      }
      return searchParams.toString();
    },
  };

  const response = await mainAxios.get("/v1/reportes/pagos-alianzas", config);
  return response.data;
};

export const getReportePagosCSV = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/reportes/pagos-alianzas/file",
      body,
      {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Reporte_Pagos_Alianzas.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error al descargar CSV:", error);
    throw error;
  }
};

export const getReporteRedencionesAlianzas = async (filters) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      alianza: filters.alianza,   
      tipo: filters.tipo ?? undefined,  
      fechas: filters.fechas,            
      limit: filters.limit ?? 10,
      page: filters.page ?? 0,
      order: filters.order ?? "desc",
    },
    
    paramsSerializer: (params) => {
      const sp = new URLSearchParams();
      for (const key in params) {
        const val = params[key];
        if (val == null) continue;
        if (Array.isArray(val)) {
          val.forEach((v) => sp.append(key, v));
        } else {
          sp.append(key, val);
        }
      }
      return sp.toString();
    },
  };

  const response = await mainAxios.get("/v1/reportes/redenciones-alianzas", config);
  return response.data;
};


export const getReporteRedencionesCSV = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/reportes/redenciones-alianzas/file",
      body, 
      {
        headers: {
          Authorization: "Bearer " + getAgenteAccessToken(),
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], { type: "application/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "Reporte_Redenciones_Alianzas.csv");
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error al descargar CSV Redenciones:", error);
    throw error;
  }
};